export class AuditDTO{
    constructor( public createdOn:any, public createdBy:string, public updatedOn:any, public updatedBy:string){
    }
}

export class AuditType extends AuditDTO{
    public createdOnStr:string;
    public updatedOnStr:string;
    constructor(audit:AuditDTO, createdOnStr:string, updatedOnStr:string) {
        super(audit.createdOn, audit.createdBy, audit.updatedOn, audit.updatedBy);
        this.createdOnStr = createdOnStr;
        this.updatedOnStr = updatedOnStr;
    }
}
